// extracted by mini-css-extract-plugin
module.exports = {"global-pagesize-container":"discountsList_global-pagesize-container__1Gk8P"};